"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.minMeasure = void 0;
const compare_measure_1 = require("../compare-measure/compare-measure");
function minMeasure(...items) {
    let min = items[0];
    for (let i = 1; i < items.length; i++) {
        const item = items[i];
        if (item?.value != null && (min?.value == null || (0, compare_measure_1.compareMeasure)(min, item) > 0)) {
            min = item;
        }
    }
    if (min == null) {
        throw new TypeError('Cannot determine minimum of empty array.');
    }
    return min;
}
exports.minMeasure = minMeasure;
